function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'mp-popover-card-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-card-header': true,
            'mp-popover-card-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
            "attrs": __vjadeStringifyAttrsIfObj({
              icon: $attr(`is-segmented`) ? `segment` : `event`
            }),
            "class": {
              'svg-title-icon': true
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-card-header-title': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("" + ($attr(`title`)) + "");
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-card-header-subtitle': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("" + ($attr(`subtitle`)) + "");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'theme': `tertiary`
            }),
            "on": {
              click: $helpers.handleClose
            },
            "class": {
              'mp-card-header-close': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon: `x`
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'body': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("slot"));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'footer': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = ($helpers.getMainOptions());
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, buttonOption, idx) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'button-option-container': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((!buttonOption.values) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-button", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          theme: `secondary`,
                          icon: buttonOption.icon,
                          disabled: buttonOption.isDisabled
                        }),
                        "on": {
                          click: $helpers.handleSelect(buttonOption),
                          mouseover: $helpers.handleFocusItem(buttonOption),
                          mouseout: $helpers.handleUnfocusItem,
                          disabled: buttonOption.disabled,
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("span", {
                          "class": {
                            'button-label': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("" + (buttonOption.label) + "");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat((buttonOption.tooltip) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            'max-width': `250px`
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("" + (buttonOption.tooltip) + "");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this)) : (buttonOption.values) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-select", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          sections: JSON.stringify([{
                            items: buttonOption.values
                          }]),
                          'selected-option': buttonOption.label,
                          disabled: buttonOption.isDisabled,
                        }),
                        "on": {
                          change: $helpers.handleChange,
                          focusItem: $helpers.handleFocusItem(),
                          menuChange: $helpers.handleUnfocusItem,
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat((buttonOption.tooltip) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            'max-width': `250px`
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("" + (buttonOption.tooltip) + "");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var idx = $$objKey;
                  if ($$obj.hasOwnProperty(idx)) {
                    $$iterated = true;
                    var buttonOption = $$obj[idx];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'button-option-container': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((!buttonOption.values) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-button", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              theme: `secondary`,
                              icon: buttonOption.icon,
                              disabled: buttonOption.isDisabled
                            }),
                            "on": {
                              click: $helpers.handleSelect(buttonOption),
                              mouseover: $helpers.handleFocusItem(buttonOption),
                              mouseout: $helpers.handleUnfocusItem,
                              disabled: buttonOption.disabled,
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("span", {
                              "class": {
                                'button-label': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("" + (buttonOption.label) + "");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat((buttonOption.tooltip) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                'max-width': `250px`
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("" + (buttonOption.tooltip) + "");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this)) : (buttonOption.values) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-select", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              sections: JSON.stringify([{
                                items: buttonOption.values
                              }]),
                              'selected-option': buttonOption.label,
                              disabled: buttonOption.isDisabled,
                            }),
                            "on": {
                              change: $helpers.handleChange,
                              focusItem: $helpers.handleFocusItem(),
                              menuChange: $helpers.handleUnfocusItem,
                            },
                          }));
                          __jade_nodes = __jade_nodes.concat((buttonOption.tooltip) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                'max-width': `250px`
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("" + (buttonOption.tooltip) + "");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());
          __jade_nodes = __jade_nodes.concat(($helpers.hasOverflow()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'button-option-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  sections: JSON.stringify([{
                    items: $helpers.getOverflowOptions()
                  }]),
                  icon: JSON.stringify({
                    leftIcon: `hor-ellipsis`
                  }),
                }),
                "on": {
                  change: $helpers.handleChange
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;